const specialLandings = {
  '/aliexpress-trial': 'ru',
  '/picsartpro-trial': 'ru',
  '/ivi-trial': 'ru',
  '/not-found': 'en',
  '/draft': 'en',
};

export default specialLandings;
